import { Button, Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";

interface IErrorDialogProps {
    show: boolean;
    title: string;
    body: string | React.ReactNode;
    onClose: () => void;
}

const ErrorDialog = ({ show, title, body, onClose }: IErrorDialogProps) => {
    const intl = useIntl();
    return (
        <Dialog
            show={show}
            title={(
                <>
                    <span className="rioglyph rioglyph-remove-circle margin-right-10 text-color-danger" />
                    <span>{title}</span>
                </>
            )}
            footer={
                <div className='display-flex justify-content-end'>
                    <Button bsStyle='primary' onClick={onClose}>
                        {intl.formatMessage({ id: "intl-msg:dialogs.errorDialog.close" })}
                    </Button>
                </div>
            }
            body={body}
            bsSize={Dialog.SIZE_XS}
            onClose={onClose}
        />
    );
}

export default ErrorDialog;